import t from 'react-translate';
import { css } from '@emotion/react';
import CountdownDisplay from 'lecture_pages/components/ai-role-play/ai-conversation-modal/voice-mode/countdown-display';
import NvIcon from 'shared/components/nv-icon';
import { halfSpacing } from 'styles/global_defaults/scaffolding';
import { VoiceRecordingState } from '../context';

type RecordingStatusProps = {
  recordingState: VoiceRecordingState,
};

const styles = css`
  .recording-circle {
    width: ${halfSpacing}px;
    height: ${halfSpacing}px;
    border-radius: 50%;
  }
`;

const RecordingStatus = ({ recordingState }: RecordingStatusProps) => {
  switch (recordingState) {
    case VoiceRecordingState.COUNTDOWN:
      return <CountdownDisplay />;
    case VoiceRecordingState.RECORDING:
      return (
        <div css={styles} className='d-flex align-items-center'>
          <div className='recording-circle bg-danger' />
          <p className='ml-1 mb-0 text-regular font-weight-bold'>{t.FILE_UPLOAD.RECORDING()}</p>
        </div>
      );
    case VoiceRecordingState.COMPLETED:
      return (
        <div className='d-flex align-items-center'>
          <NvIcon
            icon='check'
            className='d-flex align-items-center text-success'
            size='small'
          />
          <p className='mb-0 text-regular font-weight-bold ml-1'>
            {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.ROLE_PLAY_COMPLETED()}
          </p>
        </div>
      );
    default:
      return null;
  }
};

export default RecordingStatus;
